import StatsLink from 'components/stats-link-list/StatsLink';
import Link from 'components/link/Link';
import PortfolioContent from 'components/portfolio-content/PortfolioContent';
import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';

import { IStatsLinkList } from 'source/NFR.types';

const StatsLinkList: React.FC<IStatsLinkList> = ({ heading, statsLinks = [], aboutImage, seeMoreLink }) => {
  return (
    <PortfolioContent title={heading}>
      <div className="stats-link-list">
        <div className="stats-link-list--links">
          {statsLinks?.map((statsLink, index) => (
            <StatsLink {...statsLink} key={`${statsLink.title}-${index}`} />
          ))}
        </div>
        {aboutImage?.src && (
          <div className="stats-link-list--image">
            <Image {...imageSizes.statsLinkListAbout} {...aboutImage} />
          </div>
        )}
        {seeMoreLink && (
          <Link className="stats-link-list--see-more-link" {...seeMoreLink} theme="secondary" useButtonStyles />
        )}
      </div>
    </PortfolioContent>
  );
};

StatsLinkList.displayName = 'StatsLinkList';

export default StatsLinkList;
